import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./PrivacyPolicy.css";  // Assure-toi de créer un fichier CSS séparé pour les styles

const PrivacyPolicy = () => {
  return (
    <Container fluid className="privacy-policy">
      <Row className="justify-content-center">
        <Col md={10} className="privacy-policy-content">
          {/* <p className="policy-intro">
            Chez <strong>ESISA</strong>, nous nous engageons à protéger la confidentialité de vos données personnelles.
            Cette politique de confidentialité explique comment nous collectons, utilisons, et protégeons vos informations
            personnelles lorsque vous utilisez nos services.
          </p> */}

          <section className="policy-section">
            <h2>1. Informations collectées</h2>
            <p>
              Nous collectons des informations personnelles que vous nous fournissez lorsque vous remplissez un formulaire
              sur notre site, telles que votre Nom et prénom, Numéro de téléphone et Message.
            </p>
         
            <p>
              Nous collectons également des données de navigation, telles que votre adresse IP, votre type de navigateur,
              et d'autres informations de connexion lorsque vous naviguez sur notre site.
            </p>
          </section>

          <section className="policy-section">
            <h2>2. Utilisation des informations</h2>
            <p>
              Les informations collectées sont utilisées pour :
            </p>
            <ul>
              <li>Répondre à vos demandes ou questions</li>
              <li>Envoyer des informations sur nos services ou offres</li>
        
            </ul>
          </section>

          {/* <section className="policy-section">
            <h2>3. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données personnelles
              contre la perte, l'accès non autorisé, ou l'altération. Toutefois, il est important de noter qu'aucune méthode
              de transmission sur Internet n'est totalement sécurisée.
            </p>
          </section> */}

          <section className="policy-section">
            <h2>4. Vos droits</h2>
            <p>
              Conformément à la législation applicable, vous disposez des droits suivants concernant vos informations personnelles :
            </p>
            <ul>
              <li><strong>Droit d'accès :</strong> Vous pouvez demander à accéder aux données que nous détenons à votre sujet.</li>
              <li><strong>Droit à l'effacement :</strong> Vous pouvez demander à supprimer ou corriger vos données personnelles.</li>
            </ul>
            <p>
              Pour exercer ces droits, veuillez nous contacter via notre page de contact ou par e-mail.
            </p>
          </section>

          {/* <section className="policy-section">
            <h2>5. Partage de vos informations</h2>
            <p>
              Nous ne vendons ni ne louons vos informations personnelles à des tiers. Cependant, nous pouvons être amenés à partager vos
              données avec des prestataires de services tiers qui nous aident à gérer notre site web ou nos services.
            </p>
          </section> */}

          {/* <section className="policy-section">
            <h2>6. Cookies</h2>
            <p>
              Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers stockés
              sur votre appareil qui nous aident à analyser l'utilisation de notre site et à personnaliser les services.
            </p>
          </section>

          <section className="policy-section">
            <h2>7. Modification de la politique de confidentialité</h2>
            <p>
              Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Toute modification sera publiée sur cette
              page, et la date de la dernière révision sera mise à jour en bas de cette page.
            </p>
          </section> */}

          {/* <p className="policy-footer">
            <small>Dernière mise à jour : février 2025</small>
          </p> */}
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
